/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_IntroInputs */

const en_gc_editor_intro = /** @type {(inputs: Gc_Editor_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try GridCraft online with the official ArtCraft spreadsheet editor. Choose a starting point, explore the formulas, and save a workbook you can keep.`)
};

const zh_gc_editor_intro = /** @type {(inputs: Gc_Editor_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用 ArtCraft 官方编辑器在线体验 GridCraft。选择起步示例，探索公式，并保存属于你的工作簿。`)
};

/**
* | output |
* | --- |
* | "Try GridCraft online with the official ArtCraft spreadsheet editor. Choose a starting point, explore the formulas, and save a workbook you can keep." |
*
* @param {Gc_Editor_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_intro = /** @type {((inputs?: Gc_Editor_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_intro(inputs)
	return zh_gc_editor_intro(inputs)
});
export { gc_editor_intro as "gc.editor.intro" }